import { render, staticRenderFns } from "./AcceptInvitePage.vue?vue&type=template&id=c740c554&"
import script from "./AcceptInvitePage.vue?vue&type=script&lang=js&"
export * from "./AcceptInvitePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports